import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';
import * as R from 'ramda';
import {
  resource,
} from 'common/store/selectors';

export const getScope = ({ widgets: { statusForLast4HoursData } }) => statusForLast4HoursData;

const chooseSafeNumber = (l, r) => (Number(r) || l);

const defaultStatusForLast4HoursWidgetData = [
  {
    name: "unknown",
    online: 0,
    offline: 0,
    unknown: 0,
  },
]

export const {
  isLoading,
  getResourceContext,
  getResourceMaybe,
} = resource.factory(getScope);

export const getError = createSelector(
  getScope,
  ({ error }) => error,
);

export const getStatusForLast4HoursWidgetMaybe = createSelector(
  getResourceMaybe,
  resourceMaybe => S.map(
    R.mergeDeepWith(chooseSafeNumber, defaultStatusForLast4HoursWidgetData),
    S.chain(S.toMaybe, resourceMaybe),
  ),
);
